"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = getEmotionCache;

var _cache = _interopRequireDefault(require("@emotion/cache"));

function getEmotionCache(props) {
  return (0, _cache.default)(props !== null && props !== void 0 ? props : {
    key: "css"
  });
}